import { ResumeRecord } from './../jobs/resumerecord';
import Vue from 'vue';
import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import { User } from './userdto';
import axios from 'axios';
import { vxm } from '@/store.vuex';
import { WLUser } from './wluser';
import { AuthParams } from './authparams';
import { ChangePasswordRequest } from './changepasswordrequest';
import router from '../../router';
import { UserProfile } from './profile';
import { OAuthPassport } from './socialauthparams';
import { ApplyRequestWrapper } from './../jobs/jobapply';
import { OtpValidationToken } from './otptoken';
import { DropboxSelection } from './dropbox';
import { AppUserOtpInfo } from './appuserotpinfo';
import { UserJobHistoryListResponse } from '../jobs/userjobhistoryresponse';
import { Request } from './request';
import { SurveyListRequest } from './../candidatesurvey/candidatesurveyresponse';
import { UserParams } from './userparams';
import { DocumentResponse } from '../skills/documentresponse';
import { ChangeEmailRequest } from './changeemailrequest';
import { ChangePhoneNumberRequest } from './changephonenumberrequest';
import { ChangePhoneNumberConfirmOtpRequest } from './changephonenumberconfirmotprequest';
import { ChangePhoneNumberResendOtpRequest } from './changephonenumberresendotprequest';
import { Language } from './language';
import moment from 'moment';
import { CustomFields } from './customfields';
import { OtpRequestToken } from './otprequesttoken';
import { Rudderstack } from '../utility/rudderstack';
import { MissingStepEstimateInfo } from './MissingStepEstimateInfo';
import { UserPersonalInformation } from './personalInformation';
import { i18n } from '@/plugins/i18n';

declare var window: any;

@Module({ namespacedPath: 'users/' })
export class UserStore extends VuexModule {
  private newUser: boolean = false;
  private user: User = new WLUser();
  private isAuthenticated: boolean = false;
  private jwtToken: string = '';
  private refreshToken: string = '';
  private jwtOtpToken: string = '';
  private jwtOtpRefreshToken: string = '';
  private companyCode: string = '';
  private smEmail: string = '';
  private userProfile: UserProfile = new UserProfile();
  private oauthPassport: OAuthPassport = new OAuthPassport();
  private errorMesaageLogin: string = '';
  private dropboxToken: string = '';
  private refId: string = '';
  private uuid: string = '';
  private userJobHistoryListResponse: UserJobHistoryListResponse = new UserJobHistoryListResponse();
  private loadingProfile: boolean = false;
  private userDeviceAppTkn: string = '';
  private userParams: UserParams = new UserParams();
  private educationHistoryList: Array<any> = [];
  private professionalReferenceList: Array<any> = [];
  private questionCheckList: Array<any> = [];
  private certificationQuestionList: Array<any> = [];
  private skillChecklistHeader: string = '';
  private checkListMetaData = {};
  private checkListCertifiedBy: string = '';
  private degreeOptions: Array<any> = [];
  private missedMandatorySteps: Array<string> = [];
  private profileWizardSteps: Array<any> = [];
  private requiredStepsInfo = {
    requiredStepsMissing: [],
    requiredStepsCompleted: [],
    stepsRequired: [],
  };
  private missingStepsEstimateInfo: MissingStepEstimateInfo = {
    totalCompletionEstimate: "",
    missingSteps: []
  };
  private candidateCustomFields: CustomFields = new CustomFields();
  private userRoles: Array<any> = [];
  private routeAfterLogin: string = '';
  private userID: string = '';
  private surveyuserqualifierid: string = '';
  private routeAfterUniversalLogin: string = '';
  private emailVerified: boolean = false;
  private forceChangePwd: boolean = false;
  private userAccountStatus: string = '';
  private registrationStatus = {
    EMAIL_UNREGISTERED: { routeName: 'Signup' },
    ADMIN_REGISTRATION: { routeName: 'Signup' },
    PENDING_REGISTRATION: { routeName: 'Signup' },
    QUICK_APPLY_RESUME_REGISTRATION: { routeName: 'Signup' },
    DIRECT_REGISTRATION: { routeName: 'LoginForm' },
    ACCOUNT_LOCKED: { routeName: 'AccountLocked' },
  };
  private routerAfterOTPForm: string = '';
  private socialMediaRegistered: boolean = false;
  private routeParamsAfterLogin: any = {};
  private personalInformation: UserPersonalInformation = new UserPersonalInformation();
  private rudderstack: Rudderstack = new Rudderstack();
  private userLanguagePrefrence = 'en' ;

  ///////////////////////////////////////////////////////////////
  public get getRouterAfterOTPForm(): string {
    let nextRoute =
      this.routerAfterOTPForm === ''
        ? this.getDefaultRouterAfterOTPForm
        : this.routerAfterOTPForm;
    console.log('getRouterAfterOTPForm', nextRoute);
    return nextRoute;
  }

  public get getDefaultRouterAfterOTPForm(): string {
    if (this.routeAfterLogin === "myjobstatus") { 
      return this.routeAfterLogin;
    }
    if (vxm.configs.GuidedSignupEnabled && vxm.utility.IsNewlyRegisteredUser
      && !vxm.jobs.SkipGuidedSignUpOnRegistration) {
      return 'GuidedSignup';
    } else {
      return vxm.configs.getGlobalConfigValue('LANDING_PAGE_AFTER_SIGN_IN') === 'HOME' ?  'Home' : 'Findjobs';
    }
  }

  public get isSocialMediaRegisterd(): boolean {
    return this.socialMediaRegistered;
  }

  public get getRouteAfterUniversalLogin(): string {
    return this.routeAfterUniversalLogin;
  }

  public get getRouterAfterLogin() {
    return this.routeAfterLogin;
  }
  public get Rudderstack(): Rudderstack {
    return this.rudderstack;
}
  public get getUserID() {
    return this.userID;
  }

  public get getSurveyuserqualifierid() {
    return this.surveyuserqualifierid;
  }

  public get UserRoles() {
    return this.userRoles;
  }

  public get EducationHistoryList() {
    return this.educationHistoryList;
  }

  public get DegreeOptions() {
    return this.degreeOptions;
  }

  public get MissedMandatorySteps() {
    return this.missedMandatorySteps;
  }

  public get ProfileWizardSteps() {
    return this.profileWizardSteps;
  }

  public get User(): WLUser {
    return this.user;
  }

  public get UserParams(): UserParams {
    return this.userParams;
  }

  public get ProfessionalReferenceList() {
    return this.professionalReferenceList;
  }
  public get QuestionCheckList() {
    return this.questionCheckList;
  }

  public get CertificationQuestionList() {
    return this.certificationQuestionList;
  }

  public get SkillChecklistHeader() {
    return this.skillChecklistHeader;
  }

  public get CheckListMetaData() {
    return this.checkListMetaData;
  }

  public get CheckListCertifiedBy() {
    return this.checkListCertifiedBy;
  }

  public get UserCustomMetaData() {
    return this.candidateCustomFields;
  }

  public get EmailVerified(): boolean {
    return this.emailVerified;
  }

  public get ForceChangePwd(): boolean {
    return this.forceChangePwd;
  }

  public get UserAccountStatus(): string {
    return this.userAccountStatus;
  }

  public get myPersonalInformation(): UserPersonalInformation {
    return this.personalInformation;
  }

  @mutation
  public setSocialMediaRegisterd(value: boolean) {
    this.socialMediaRegistered = value;
  }

  @mutation
  public setEmailVerified(value: boolean) {
    this.emailVerified = value;
  }

  @mutation
  public setForceChangePwd(value: boolean) {
    this.forceChangePwd = value;
  }

  @mutation
  public setNotifcationtypeMap(notificationPreference){
    this.userProfile.notificationTypeMap.EMAIL = notificationPreference.email;
    this.userProfile.notificationTypeMap.SMS = notificationPreference.sms;
    this.userProfile.notificationTypeMap.PUSH_NOTIFICATION = notificationPreference.push;
    this.userProfile.notificationTypeMap.WHATSAPP = notificationPreference.whatsapp;
    this.userProfile.notificationTypeMap.VOICE = notificationPreference.voice;
    this.userProfile.notificationTypeMap.MARKETING_EMAIL = notificationPreference.marketing;
  }
  
  @mutation
  public setUserAccountStatus(userAccountStatus: string) {
    this.userAccountStatus = userAccountStatus;
  }

  @mutation
  public setRouterAfterOTPForm(value: string) {
    this.routerAfterOTPForm = value;
  }

  @mutation
  public setRouteNextToUniversalLogin(payload) {
    this.routeAfterUniversalLogin = payload;
  }
  @mutation
  public setRouteAfterLogin(payload) {
    this.routeAfterLogin = payload;
  }
  @mutation
  public setRouteParamsAfterLogin(payload) {
    this.routeParamsAfterLogin = payload;
  }

  @mutation
  public setUserID(payload) {
    this.userID = payload;
  }

  @mutation
  public setSurveyuserqualifierid(payload) {
    this.surveyuserqualifierid = payload;
  }

  @mutation
  public setUserRoles(payload) {
    this.userRoles = payload;
  }

  @mutation
  public setProfileWizardSteps(payload) {
    //making certification step mandatory
    this.profileWizardSteps = payload;
  }

  @mutation
  public setDegreeOptions(payload) {
    this.degreeOptions = payload;
  }

  @mutation
  public setQuestionCheckList(payload) {
    this.questionCheckList = payload;
  }

  @mutation
  public setUserParams(params: UserParams) {
    this.userParams = params;
  }

  @mutation
  public setRetrievedEmail(retrievedEmail: string) {
    this.userParams.retrievedEmail = retrievedEmail;
  }

  @mutation
  public setDuplicateCheckRequired(duplicateCheckRequired: boolean) {
    this.userParams.checkForDuplicate = duplicateCheckRequired;
  }

  @mutation
  public setPopulateSignupPage(populateSignupPage: boolean) {
    this.userParams.populateSignupPage = populateSignupPage;
  }

  @mutation
  public setFirstName(firstName: string) {
    this.userParams.firstName = firstName;
  }

  @mutation
  public setLastName(lastName: string) {
    this.userParams.lastName = lastName;
  }

  @mutation
  public setEmail(email: string) {
    this.userParams.email = email;
  }

  @mutation
  public setPhoneNumber(phoneNum: string) {
    this.userParams.phone = phoneNum;
  }

  @mutation
  public setEducationHistoryList(list) {
    this.educationHistoryList = list;
  }

  @mutation
  public setProfessionalReferenceList(list) {
    list = list.map((reference) => {
      if (!reference.salutation) {
        reference.salutation = '';
      }
      if (!reference.referenceFirstName && reference.referenceName) {
        reference.referenceFirstName = reference.referenceName.split(' ')[0];
        reference.referenceLastName =
          reference.referenceName.split(' ')[1] || '';
      }
      if (!reference.referenceJobTitleWhenWorkedTogether && reference.title) {
        reference.referenceJobTitleWhenWorkedTogether = reference.title;
      }
      return reference;
    });
    this.professionalReferenceList = list;
  }

  @mutation
  public setCertificationQuestionList(list) {
    this.certificationQuestionList = list;
  }

  @mutation
  public setMissedMandatorySteps(payload) {
    this.missedMandatorySteps = payload;
  }

  @action({ mode: 'mutate' })
  public setUserCustomMetaData(payload: CustomFields) {
    this.candidateCustomFields.candidateCustomMetaData =
      payload.candidateCustomMetaData;
  }

  @mutation
  public setPersonalInformation(payload: any) {
    this.personalInformation = payload;
  }

  ////////////////////////////////////////////////////////

  public get isPartialSignup(): boolean {
    if (this.refId && this.uuid) {
      return true;
    } else {
      return false;
    }
  }

  ////////////////////////////////////////////////////////

  public get isLoggedIn(): boolean {
    return this.isAuthenticated;
  }
  public get isNewUser(): boolean {
    return this.newUser;
  }

  ////////////////////////////////////////////////////////

  public get getToken(): string {
    return this.jwtToken;
  }

  public get UserDeviceAppTkn() {
    return this.userDeviceAppTkn;
  }

  public get getRefreshToken(): string {
    return this.refreshToken;
  }

  public get getOtpToken(): string {
    return this.jwtOtpToken;
  }

  public get getUserLang(): string {
    //return localStorage.userLang || 'en';
    return Vue.cookies.get('userLang') || 'en';
  }

  public get getDropboxToken(): string {
    return this.dropboxToken;
  }

  public get myUserProfile(): UserProfile {
    return this.userProfile;
  }

  public get getCompanyCode(): string {
    return vxm.jobs.BrandingInfo.companycode;
  }

  public get socEmail(): string {
    return this.smEmail;
  }

  public get OAuthPassport() {
    return this.oauthPassport;
  }
  public get getErrorMesaageLogin() {
    return this.errorMesaageLogin;
  }

  public get UserJobHistoryListResponse(): UserJobHistoryListResponse {
    return this.userJobHistoryListResponse;
  }

  public get isLoadingProfile(): boolean {
    return this.loadingProfile;
  }

  public get getUiid(): string {
    if (!this.uuid) {
      const wl = window.WorkLLama;
      if (wl && wl.uuid !== 'null') {
        this.setUuid(wl && wl.uuid);
      }
    }
    return this.uuid;
  }

  public get RequiredStepsInfo() {
    return this.requiredStepsInfo;
  }

  public get MissingStepsEstimateInfo() {
    return this.missingStepsEstimateInfo;
  }

  public get signupURL() {
    if (vxm.utility.AppWebView) {
      return '/wl-sso-sec-svc/api/user/register';
    }
    if (vxm.utility.UserDeviceToken) {
      return '/wl-sso-sec-svc/api/user/v1/register';
    }
    return vxm.utility.useLoginSignupV2
      ? '/wl-sso-sec-svc/api/user/v1/register'
      : '/wl-sso-sec-svc/api/user/register';
  }

  public get UserLanguagePrefrence(){
    return this.userLanguagePrefrence;
  }

  ////////////////////////////////////////////////////////

  @mutation
  public setCheckListMetaData(payload) {
    this.checkListMetaData = payload;
  }

  @mutation
  public setCheckListCertifiedBy(payload) {
    this.checkListCertifiedBy = payload;
  }

  @mutation
  public setUserDeviceAppTkn(token: string) {
    this.userDeviceAppTkn = token;
  }

  @mutation
  public setErrorMesaageLogin(errorMesaage: string) {
    this.errorMesaageLogin = errorMesaage;
  }

  @mutation
  public setUuid(uuid: string) {
    this.uuid = uuid;
  }

  @mutation
  public setRefId(refId: string) {
    this.refId = refId;
  }

  @mutation
  public setToken(token: string) {
    this.jwtToken = token;
    Vue.cookies.set('jwtToken', token);
  }

  @mutation
  public setRefreshToken(token: string) {
    this.refreshToken = token;
  }

  @mutation
  public setOtpToken(token: string) {
    this.jwtOtpToken = token;
    Vue.cookies.set('jwtOtpToken', token);
  }

  @mutation
  public setUserLanguagePrefrence(lang: string) {
    this.userLanguagePrefrence = lang;
  }



  @action({ mode: 'mutate' })
  public async setUserLang(lang: string) {
    //localStorage.userLang = lang;
    Vue.cookies.set('userLang', lang);
    if (this.UserLanguagePrefrence !== lang ){
    const languageRegionMap = {
    en: 'en-US',
    fr: 'fr-CA',
    de: 'de-DE',
    'fr-CA':'fr-CA'
  };
    const token = 'Bearer ' + this.getToken;
    if(this.getToken){
      const resp = await axios.post(
      '/wl-profile-svc/api/v1/user-preference/locale',
      null,
      { 
        params: {
          locale: languageRegionMap[lang]
        },
        headers: { 'Content-Type': 'application/json', Authorization: token } },
      );
      return resp.data;
    }
  }
  }

  @mutation
  public setDropboxToken(token: string) {
    this.dropboxToken = token;
  }

  @mutation
  public setAuthStatus(status: boolean) {
    this.isAuthenticated = status;
  }

  @mutation
  public setNewUser(status: boolean) {
    this.newUser = status;
  }

  @mutation
  public setUser(userDetails: WLUser) {
    this.user = userDetails;
  }

  @mutation
  public setLoadingProfile(loadingprofile: boolean) {
    this.loadingProfile = loadingprofile;
  }
  @mutation
  public setWorkHistory(profile) {
    this.userProfile.desiredSalary = profile.desiredSalary;
    this.userProfile.desiredMinSalary = profile.desiredMinSalary;
    this.userProfile.desiredMaxSalary = profile.desiredMaxSalary;
    this.userProfile.desiredLocations = profile.desiredLocations || [];
    this.userProfile.jobAvailability = profile.jobAvailability;
    this.userProfile.remoteWork = profile.remoteWork;
    this.userProfile.periodForSalary = profile.periodForSalary;
    this.userProfile.jobSearchStatus = profile.jobSearchStatus;
  }
  @mutation
  public setUserProfile(profile) {
    this.userProfile.userId = profile.userId;
    this.userProfile.email = profile.email;
    this.userProfile.phoneNum = profile.phoneNum;
    this.userProfile.employeeType = profile.employeeType;
    this.userProfile.firstName = profile.firstName;
    this.userProfile.middleName = profile.middleName;
    this.userProfile.lastName = profile.lastName;
    this.userProfile.preferredName = profile.preferredName;
    this.userProfile.country = profile.country;
    this.userProfile.address1 = profile.address1;
    this.userProfile.address2 = profile.address2;
    this.userProfile.blocked = profile.blocked;
    this.userProfile.city = profile.city;
    this.userProfile.state = profile.state;
    this.userProfile.zip = profile.zip;
    this.userProfile.timezone = profile.timezone;
    this.userProfile.additionalSupportRequired = profile.additionalSupportRequired;
    this.userProfile.attachements = profile.attachements;
    this.userProfile.availabilityStatus = profile.availabilityStatus;
    this.userProfile.employeeType = profile.employeeType;
    this.userProfile.resumes = profile.resumes;
    this.userProfile.notificationTypeMap = profile.notificationTypeMap;
    this.userProfile.skillTypes = profile.skillTypes;
    this.userProfile.forcePwdChg = profile.forcePwdChg;
    this.userProfile.profilePicGUID = profile.profilePicGUID;
    this.userProfile.profilePicExtType = profile.profilePicExtType;
    this.userProfile.userProfileBasePath = profile.userProfileBasePath;
    this.userProfile.userProfileStrength = profile.userProfileStrength;
    this.userProfile.userAttributeSkills = profile.userAttributeSkills;
    this.userProfile.currentPassword = profile.currentPassword;
    this.userProfile.desiredSalary = profile.desiredSalary;
    this.userProfile.desiredMinSalary = profile.desiredMinSalary;
    this.userProfile.desiredMaxSalary = profile.desiredMaxSalary;
    this.userProfile.sourceType = profile.sourceType;
    this.userProfile.desiredLocations = profile.desiredLocations || [];
    this.userProfile.jobAvailability = profile.jobAvailability;
    this.userProfile.jobAvailabilityOptions =
      profile.jobAvailabilityOptions || [];
    this.userProfile.remoteWork = profile.remoteWork;
    this.userProfile.periodForSalary = profile.periodForSalary;
    this.userProfile.currency = profile.currency;
    this.userProfile.desiredLocationString = '';
    this.userProfile.enableForum = profile.enableForum;
    this.userProfile.isJobAlertEnabled = profile.isJobAlertEnabled;
    this.userProfile.languages = profile.languages;
    this.userProfile.role = profile.role || '';
    this.userProfile.userAccountRegistrationStatus = profile.registrationStatus || "";
    window.WorkLLama.externalId = profile.externalId || "";
    this.userProfile.dob = profile.dob
      ? vxm.utility.convertUTCToLocalTime(profile.dob)
      : profile.dob;
    this.userProfile.totalFlightHours = profile.totalFlightHours;
    for (
      let index = 0;
      index < this.userProfile.desiredLocations.length;
      index++
    ) {
      if (this.userProfile.desiredLocations[index].state) {
        this.userProfile.desiredLocationString = this.userProfile.desiredLocationString
          .concat(this.userProfile.desiredLocations[index].city)
          .concat(',')
          .concat(this.userProfile.desiredLocations[index].state)
          .concat(',')
          .concat('  ');
      } else {
        this.userProfile.desiredLocationString = this.userProfile.desiredLocationString
          .concat(this.userProfile.desiredLocations[index].city)
          .concat(',')
          .concat('  ');
      }
    }
    this.userProfile.desiredLocationString.trim();
    this.userProfile.customFields = profile.customFields;
  }

  @mutation
  public setSocEmail(socEmail: string) {
    this.smEmail = socEmail;
  }

  @mutation
  public setOAuthPassport(passport: OAuthPassport) {
    this.oauthPassport = passport;
  }

  @mutation
  public setUserJobHistoryListResponse(uhlr: UserJobHistoryListResponse) {
    this.userJobHistoryListResponse = uhlr;
  }

  @mutation
  public removeUserAttributeDoc(uID: number): void {
    this.userProfile.userAttributeSkills.forEach((value) => {
      if (value.userAttribute.userAttributeID == uID)
        value.documentResponse = null;
    });
    /*let uas = this.userProfile.userAttributeSkills[index];
    uas.documentResponse = null;*/
    this.userProfile.skillTypes.forEach((value) => {
      if (value.documentList !== null)
        value.documentList = value.documentList.filter(
          (i) => i.userAttributeId != uID,
        );
    });
  }

  @mutation
  public setAvailabilityStatus(value: string): void {
    console.log('setting availability status:' + value);
    this.userProfile.availabilityStatus = value;
  }

  @action({ mode: 'mutate' })
  public async updatedAvailabilityStatus(value: string) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/updateAvailabilityStatus/' + value,
      null,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action()
  public getKeyValue(searchKey: string, obj: any): any {
    const arr = Object.entries(obj);
    const searchedItem = arr.filter(entry => entry[0] === searchKey);
    if (searchedItem && searchedItem.length > 0) {
      return searchedItem[0][1]
    }
    return '';
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public loginWithApple() {
    let socialConfigs = window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.SocialLoginConfig : vxm.jobs.BrandingInfo;
    let userAuthorizationUri = "https://appleid.apple.com/auth/authorize";
    let client_id = "com.workllama.cpemerald"; // sample
    let redirect_uri = socialConfigs.PRE_ESTABLISHED_REDIRECT_URI;
    let scope = "name email";
    const uri_ = `${userAuthorizationUri}?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code id_token&state=remembermeyes&scopes=${scope}&response_mode=form_post`;
    window.location.href = uri_;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public loginWithFacebook() {
    let socialConfigs = window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.SocialLoginConfig : vxm.jobs.BrandingInfo
    let userAuthorizationUri = socialConfigs.FACEBOOK_USER_AUTHORIZATION_URI; //"https://accounts.google.com/o/oauth2/auth";
    let client_id = socialConfigs.FACEBOOK_CLIENT_ID; //"13325297702-v7j857b41paucd4g45quet4njeprc3o8.apps.googleusercontent.com";
    let redirect_uri = socialConfigs.PRE_ESTABLISHED_REDIRECT_URI; //"https://emeralduat2.nuvizzards.com/atsuser/login";
    let scope = socialConfigs.FACEBOOK_SCOPE; //"email";
    const fbURI = `${userAuthorizationUri}?scope=${scope}&client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code`;
    window.location.href = fbURI;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public loginWithGoogle() {
    let socialConfigs = window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.SocialLoginConfig : vxm.jobs.BrandingInfo
    let userAuthorizationUri =
    socialConfigs.GOOGLE_USER_AUTHORIZATION_URI; //"https://accounts.google.com/o/oauth2/auth";
    let client_id = socialConfigs.GOOGLE_CLIENT_ID; //"13325297702-v7j857b41paucd4g45quet4njeprc3o8.apps.googleusercontent.com";
    let redirect_uri = socialConfigs.PRE_ESTABLISHED_REDIRECT_URI; //"https://emeralduat2.nuvizzards.com/atsuser/login";
    let scope =
      Vue.cookies.get('OAuthProvider') === 'google_contacts'
        ? socialConfigs.GOOGLE_CONTACT_SCOPE
        : socialConfigs.GOOGLE_SCOPE; // "profile email openid https://www.googleapis.com/auth/contacts.readonly";
    //const googleURI = `${userAuthorizationUri}?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}`;
    let googleURI = `https://accounts.google.com/o/oauth2/v2/auth?scope=${scope}&access_type=offline&include_granted_scopes=true&response_type=code&redirect_uri=${redirect_uri}&client_id=${client_id}`;
    window.location.href = googleURI;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public loginWithLinkedin() {
    console.log('in loginWithLinkedin method..');
    let socialConfigs = window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.SocialLoginConfig : vxm.jobs.BrandingInfo
    let userAuthorizationUri =
    socialConfigs.LINKEDIN_USER_AUTHORIZATION_URI;
    let client_id = socialConfigs.LINKEDIN_CLIENT_ID;
    let redirect_uri = socialConfigs.PRE_ESTABLISHED_REDIRECT_URI;
    let scope = socialConfigs.LINKEDIN_SCOPE;
    const linkedinURI = `${userAuthorizationUri}?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}`;
    window.location.href = linkedinURI;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public loginWithDropbox() {
    window.location.href = '/wl-sso-sec-svc/connect/dropbox';
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getDropboxCreds(ccode: string) {
    const resp = await axios.get('/wl-sso-sec-svc/getDropboxTokenv2', {
      headers: { 'Content-Type': 'application/json' },
    });
    this.setDropboxToken(resp.data);
    console.log(resp.data);
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async login(lgn: AuthParams) {
    const vm = this;
    try {
      const resp = await axios.post('/wl-sec-svc/api/auth/login', lgn, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      if (resp.data.accessToken) {
        if (vxm.utility.useLoginSignupV2 && !vxm.users.EmailVerified) {
          return true;
        }
        if(!vxm.configs.getGlobalConfigBooelanValue('WL_MULTI_FACTOR_AUTHENTICATION_ENABLED')){
          vm.setToken(resp.data.accessToken.token);
          vm.setRefreshToken(resp.data.refreshToken.token);
          this.restartChatbotIFrame();
          if (vxm.configs.IsConfigJSONEnabled) {
           await this.getConfigDetails();
          }
          const respPromise: any = vm.getUserProfile();
          Promise.all([respPromise]).then((values) => {
            if (values[0] === false) {
              vm.setAuthStatus(false);
              return false;
            } else {
              vm.setAuthStatus(true);
              vxm.jobs.saveLocalJobs();
              return true;
            }
          });
          await vxm.notificationpreference.geUserNotificationPreferences();
        }
        return true;
      } else {
        vm.setErrorMesaageLogin(resp.data.message);
        vm.setAuthStatus(false);
        return false;
      }
    } catch (error) {
      console.log(error.response.data.message);
      vm.setErrorMesaageLogin(error.response.data.message);
      vm.setAuthStatus(false);
      return false;
    }
    return false;
  }

  ////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async unlockCandidateAccount(emailAddress: string) {
    if (emailAddress && this.getCompanyCode) {
      try {
        const TOKEN_JWT = this.getToken;
        let payload = {
          emailAddress: emailAddress,
          companyCode: this.getCompanyCode,
        };
        const resp = await axios.post(
          '/wl-profile-svc/api/user-profile//unlockCandidateAccount',
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + TOKEN_JWT,
            },
          },
        );

      } catch (error) {
        console.log(error.response.data.message);
      }
    }
  }

  ////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async verifyEmail(emailAddress: string) {
    try {
      let payload = {
        emailAddress: emailAddress,
        companyCode: this.getCompanyCode,
      };
      const resp = await axios.post(
        '/wl-profile-svc/api/user-profile/verifyEmail',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (resp.data.success) {
        this.setEmailVerified(true);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error.response.data.message);
      this.setErrorMesaageLogin(error.response.data.message);
      this.setAuthStatus(false);
      return false;
    }
    return false;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async otpLogin(lgn: AuthParams) {
    const vm = this;
    try {
      const loginResponse = await axios.post(
        '/wl-sec-svc/api/auth/login',
        lgn,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );

      if (loginResponse.data.accessToken) {

        vm.setToken(loginResponse.data.accessToken.token);
        vm.setOtpToken(loginResponse.data.accessToken.token);
        vm.setRefreshToken(loginResponse.data.refreshToken.token);
        if (vxm.configs.IsConfigJSONEnabled) {
          console.log("calling api after sigunup");
          await this.getConfigDetails();
        }
        if (!this.EmailVerified) {
          const resp = await this.verifyEmail(lgn.username);
          const USER_ACCOUNT_LOCKED = "USER_ACCOUNT_LOCKED";
          // to unlock the user account if it is locked
          if (resp && vxm.users.myUserProfile.userAccountRegistrationStatus
            && USER_ACCOUNT_LOCKED === vxm.users.myUserProfile.userAccountRegistrationStatus) {
            await this.unlockCandidateAccount(lgn.username);
          }

          this.setRouterAfterOTPForm(this.getDefaultRouterAfterOTPForm);
        }


        if (this.ForceChangePwd) {
          this.setRouterAfterOTPForm('ChangePasswordV2');
          const profileResponse = await axios.get(
            '/wl-profile-svc/api/user-profile/getProfile',
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.getToken,
              },
            },
          );
          this.setUserProfile(profileResponse.data);
        } else {
          this.restartChatbotIFrame();
          await this.getUserProfile();
        }

        //if (profileResponse.data.forcePwdChg) {
        //  this.setAuthStatus(false);
        //  return false;
        //}
        this.setAuthStatus(true);
        vxm.jobs.saveLocalJobs();
        return true;
      } else {
        vm.setErrorMesaageLogin(loginResponse.data.message);
        vm.setAuthStatus(false);
        return false;
      }
    } catch (error) {
      console.log(error.response.data.message);
      vm.setErrorMesaageLogin(error.response.data.message);
      vm.setAuthStatus(false);
      return false;
    }
    return false;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async changeOtpPassword(changePasswordRequest: ChangePasswordRequest) {
    try {
      const bearerToken = 'Bearer ' + this.getOtpToken;
      const changePasswordResponse = await axios.post(
        '/wl-profile-svc/api/user-profile/v2/changePassword',
        changePasswordRequest,
        {
          headers: {
            Authorization: bearerToken,
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );

      if (changePasswordResponse.data.success) {
        return true;
      } else {
        this.setErrorMesaageLogin(changePasswordResponse.data.errorMessage);
        return false;
      }
    } catch (error) {
      console.log(error.response.data.message);
      this.setErrorMesaageLogin(error.response.data.message);
      this.setAuthStatus(false);
    }
    return false;
  }

  @action({ mode: 'mutate' })
  public async changePassword(UpdatePasswordRequest){
    const jwtToken = vxm.users.getToken;
    const bearerToken = 'Bearer ' + jwtToken;
    const changePasswordResponse = await axios.post(
        '/wl-profile-svc/api/v2/updatePassword',
        UpdatePasswordRequest,
        {
          headers: {
            Authorization: bearerToken,
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );
      console.log('changePasswordResponse')
      return changePasswordResponse;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async completeOtpLogin() {
    if (vxm.utility.UserDeviceToken) {
      vxm.users.redirectToApp();
      return;
    }
    try {
      const routeName = this.routeAfterLogin || (vxm.jobs.BrandingInfo.LANDING_PAGE_AFTER_SIGN_IN || 'Findjobs');
      this.setRouteAfterLogin('');
      this.setOtpToken(''); // Invalidate otp token
      router.push({
        name: routeName,
        params: {
          userid: this.userID,
          surveyuserqualifierid: this.surveyuserqualifierid,
        },
      });
      return true;
    } catch (error) {
      console.log(error);
    }
    return false;
  }

  ////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async verifyAccount(emailAddress: string) {
    const vm = this;
    try {
      let payload = {
        emailAddress: emailAddress,
        companyCode: this.getCompanyCode,
      };
      const resp = await axios.post(
        '/wl-profile-svc/api/user-profile/verifyAccount',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const respData = resp.data;
      this.userProfile.email = respData ? respData.email : "";
      let accountRegistrationStatus =
        respData.accountRegistrationStatus.description;
      this.setUserAccountStatus(accountRegistrationStatus);
      this.setEmailVerified(respData.emailVerified);
      this.setForceChangePwd(respData.forceChangePwd);
      if (respData.sourceType) {
        this.setSocialMediaRegisterd(
          respData.sourceType !== '' && respData.sourceType !== 'email',
        );
      } else {
        this.setSocialMediaRegisterd(false);
      }

      vm.setRouteNextToUniversalLogin(
        this.registrationStatus[accountRegistrationStatus].routeName,
      );

      if (
        accountRegistrationStatus === 'PENDING_REGISTRATION' ||
        accountRegistrationStatus === 'ADMIN_REGISTRATION' ||
        accountRegistrationStatus === 'QUICK_APPLY_RESUME_REGISTRATION'
      ) {
        this.setEmail(respData.email);
        this.setFirstName(respData.firstName);
        this.setLastName(respData.lastName);
        this.setPhoneNumber(respData.phoneNumber);

        if (respData.referralCode) {
          vxm.referrals.setGlobalRefCode(respData.referralCode);
        }
        let populateSignupPage: boolean = true;
        this.setPopulateSignupPage(populateSignupPage);
      } else {
        this.setUserParams(new UserParams());
        this.setEmail(emailAddress);
      }
      return respData;
    } catch (error) {
       console.error(error.response.data.message);
      return false;
    }
  }

  @action({ mode: 'mutate' })
  public async redirectToApp() {
    console.log("Inside redirect To App method");
    let userInfo = new AppUserOtpInfo();
    userInfo.userDeviceToken = vxm.utility.UserDeviceToken;
    userInfo.email = this.userProfile.email;
    const respPromise = await vxm.users.initAppUserOtpInfo(userInfo);
    console.log("Checking respPromise.data.sessionToken",respPromise.data.sessionToken);
    if (respPromise.data.sessionToken) {
      const appurl = `/atsuser/regSuccess?success=true&sessionToken=${respPromise.data.sessionToken
        }&jwtToken=${vxm.users.getToken}&refreshToken=${vxm.users.getRefreshToken
      }`;
      (<any>window).location = appurl;
    }
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async socialLogin(lgn: OAuthPassport) {
    const vm = this;
    try {
      const resp = await axios.post(
        '/wl-sec-svc/api/social/login',
        { ...lgn, companyCode: vxm.jobs.BrandingInfo.companycode },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );
      if (resp.data.accessToken) {
        vm.setToken(resp.data.accessToken.token);
        vm.setRefreshToken(resp.data.refreshToken.token);
        vm.setAuthStatus(true);
        vxm.jobs.saveLocalJobs();
        this.restartChatbotIFrame();
        await vm.getUserProfile();
      } else {
        vm.setErrorMesaageLogin(resp.data.message);
        vm.setAuthStatus(false);
      }
    } catch (error) {
      console.log(error.response.data.message);
      vm.setErrorMesaageLogin(error.response.data.message);
      vm.setAuthStatus(false);
    }
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async validateOTP(otp: OtpValidationToken) {
    if (!otp.companyCode) {
      otp.companyCode = vxm.jobs.BrandingInfo.companycode;
    }
    const resp = await axios.post('/wl-sso-sec-svc/api/user/verifyOTP', otp, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    console.log('OTP Response', resp.data);
    if (resp.data.status === 'success') {
      this.setAuthStatus(true);
      // this.restartChatbotIFrame();
      this.getUserProfile();
      if (vxm.utility.useLoginSignupV2) {
        vxm.utility.setIsNewlyRegisterdUser(false);
      }
      return resp.data;
    } else {
      return resp.data;
    }
  }

  @action({ mode: 'mutate' })
  public async anonValidateOTP(otp: OtpValidationToken) {
    if (!otp.companyCode) {
      otp.companyCode = vxm.jobs.BrandingInfo.companycode;
    }
    const resp = await axios.post('/wl-sso-sec-svc/api/user/verifyOTP', otp, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    console.log('OTP Response', resp.data);
    if (resp.data.status === 'success') {
      router.push({ name: 'Login' });
    } else {
      return resp.data;
    }
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async sendOTP() {
    const resp = await axios.post(
      '/wl-sso-sec-svc/api/user/resendOTP',
      {
        userIdStr: this.myUserProfile.email,
        companyCode: vxm.jobs.BrandingInfo.companycode,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    console.log('OTP Response', resp.data);
    // this.setAuthStatus(true);
    // this.getUserProfile();
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async resendOTP(email: string) {
    const resp = await axios.post(
      '/wl-sso-sec-svc/api/user/resendOTP',
      {
        userIdStr: email,
        companyCode: vxm.jobs.BrandingInfo.companycode,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    console.log('OTP Response', resp.data);
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getUserProfile(fromSignUp: boolean = false) {
    this.setOtpToken('');
    try {
      const token = 'Bearer ' + this.getToken;
      const resp = await axios.get(
        '/wl-profile-svc/api/user-profile/getProfile',
        {
          headers: { 'Content-Type': 'application/json', Authorization: token },
        },
      );
      this.setUserProfile(resp.data);
      console.log("checking userDevice token inside getUserProfile Method ",vxm.utility.UserDeviceToken);
      if (vxm.utility.UserDeviceToken) {
        console.log("inside redirectToApp if loop");
        await this.redirectToApp();
        return;
      }
      if (resp.data.forcePwdChg && !vxm.utility.useLoginSignupV2) {
        router.push({ path: '/anon-change-password' });
        this.setAuthStatus(false);
        return false;
      }
      this.setAuthStatus(true);
      if (fromSignUp) {
        vxm.jobs.saveLocalJobs();
      }
      const goTo = Vue.cookies.get('NavigateTo_ID');
      const apply = Vue.cookies.get('apply');
      const submitJobApplicationId = Vue.cookies.get('SubmitJobApplicationId');
      const arr = goTo ? goTo.split(':') : goTo;
      if (!fromSignUp && goTo && submitJobApplicationId) {
        const jobID = parseInt(arr[1], 10);
        Vue.cookies.remove('SubmitJobApplicationId');
        router.push({
          name: 'Jobdetails',
          params: { JobID: jobID + '' },
          query: { apply: 'true' },
        });
        return;
      } else if (goTo && !fromSignUp) {
        Vue.cookies.remove('NavigateTo_ID');
        Vue.cookies.remove('apply');
        const jobApply = new ApplyRequestWrapper();
        jobApply.accessToken = this.getToken;
        jobApply.applyRequest.jobPostingId = parseInt(arr[1], 10);
        jobApply.applyRequest.companyCode = vxm.jobs.BrandingInfo.companycode;
        console.log(goTo);
        vxm.utility.IsNewlyRegisteredUser &&
        vxm.configs.GuidedSignupEnabled
          ? router.push({ name: 'GuidedSignup' })
          : router.push({
              name: 'Jobdetails',
              params: { JobID: jobApply.applyRequest.jobPostingId + '' },
              query: { apply: apply },
            });
      } else if (Vue.cookies.get('referringComponent') === 'Invite') {
        router.push('/invite');
        Vue.cookies.remove('referringComponent');
      } else {
        Vue.cookies.remove('OAuthRegistrationType');
        let homePage: any;
        if (window.WorkLLama.isConfigJSONEnabled === 'true') {
          homePage = vxm.configs.ClientConfigs.slideMenuOptions.find(
            (route) => route.sectionKey === 'HOME',
          );
        } else {
          homePage = vxm.jobs.BrandingInfo.leftMenu.slideMenuOptions.find(
            (route) => route.alias === 'home',
          );
        }
        let routeName = '';
        if (
          vxm.utility.IsNewlyRegisteredUser &&
          vxm.configs.GuidedSignupEnabled
        ) {
          routeName = 'GuidedSignup';
        } else if (this.routeAfterLogin) {
          routeName = this.routeAfterLogin;
        } else if (
          vxm.configs.getGlobalConfigValue('LANDING_PAGE_AFTER_SIGN_IN') === 'FIND_JOBS'
        ) {
          routeName = 'Findjobs';
        } else if (
          homePage &&
          homePage.signInVisibility &&
          this.routeAfterLogin != null
        ) {
          routeName = 'Home';
        } else {
          routeName = 'FindJobs';
        }
        this.setRouteAfterLogin('');
        if (routeName === 'myjobstatus') {
          router.push({ path: "/myjobstatus" })
        } else {
          router.push({
            name: routeName,
            params: {
              ...this.routeParamsAfterLogin,
              userid: this.userID,
              surveyuserqualifierid: this.surveyuserqualifierid,
            },
          });
        }
        this.setRouteParamsAfterLogin({});
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
    return;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getUserProfileAndNavigateTo(component: string) {
    const token = 'Bearer ' + this.getToken;
    const vm = this;
    vm.setLoadingProfile(true);
    return axios
      .get('/wl-profile-svc/api/user-profile/getProfile', {
        headers: { 'Content-Type': 'application/json', Authorization: token },
      })
      .then(
        function(response) {
          console.log('setting loading flag1:' + false);
          vm.setUserProfile(response.data);
          vm.setLoadingProfile(false);
        }.bind(this),
      )
      .catch(
        function() {
          console.log('setting loading flag2:' + false);
          vm.setLoadingProfile(false);
        }.bind(this),
      );

    /* const resp = await axios.get(
      "/wl-profile-svc/api/user-profile/getProfile",
      { headers: { "Content-Type": "application/json", Authorization: token } }
    );
    this.setUserProfile(resp.data);*/

    // router.push({ name: component });
  }

  @action({ mode: 'mutate' })
  public async getProfileDetails() {
    router.push({ name: 'Myprofile' });
  }

  @action({ mode: 'mutate' })
  public async updatedUserProfile() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/user-profile/getProfile',
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    this.setUserProfile(resp.data);
  }

  @action({ mode: 'mutate' })
  public async getSourceTypeDetails() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.get('/wl-profile-svc/api/v2/sourcetype', {
      headers: { 'Content-Type': 'application/json', Authorization: token },
    });
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async saveSourceTypeDetails(sourceType) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/sourcetype',
      sourceType,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async getSkills() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.get('/wl-profile-svc/api/v1/skills', {
      params: {
        locale: vxm.utility.langaugeRegionMapping
      },
      headers: { 'Content-Type': 'application/json', Authorization: token },
    });

    const payload = {
      ...this.myUserProfile,
      skillTypes: (resp.data.data && resp.data.data.skillTypes) || [],
    };
    this.setUserCustomMetaData(
      (resp.data.data && resp.data.data.customFields) || [],
    );
    this.setUserProfile(payload);
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getSurveyList(surveyListRequest: SurveyListRequest) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/surveys',
      surveyListRequest,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }
  ///////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async fetchSelectedLanguages() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.get('/wl-profile-svc/api/v1/languages', {
      headers: { 'Content-Type': 'application/json', Authorization: token },
    });
    console.log('rsponse:', resp.data);
    console.log('rsponse:', resp.data.success);
    return resp.data;
  }
  ///////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async updateLanguage(languages: Language) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/languages',
      languages,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    console.log('rsponse:' + resp.data);
    console.log('rsponse:' + resp.data.success);
    if (resp.data.success) {
      this.getProfileStrength();
    }
    // router.push("myprofile");

    return resp.data;
  }
  ////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async fetchLanguages() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.get('/wl-profile-svc/api/v2/language', {
      headers: { 'Content-Type': 'application/json', Authorization: token },
    });
    console.log('rsponse:', resp.data);
    console.log('rsponse:', resp.data.success);
    return resp.data;
  }
  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async saveUserProfile({ userProfile, isPartofRegistration }) {
    let payload = { ...userProfile };

    payload.doNotTriggerEvent = 'false';
    if (typeof isPartofRegistration == 'boolean' && isPartofRegistration) {
      payload.doNotTriggerEvent = 'true';
    }
    if (payload.dob && typeof payload.dob !== 'number') {
      payload.dob = vxm.utility.convertLocalTimeToUTC(payload.dob);
    } else if (typeof payload.dob === 'number') {
      payload.dob = vxm.utility.convertLocalTimeInEpochToUTC(payload.dob);
    }
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/updateProfile',
      payload,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    console.log('rsponse:' + resp.data);
    console.log('rsponse:' + resp.data.success);
    if (resp.data.success) {
      this.getProfileStrength();
    }
    // router.push("myprofile");

    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async savePersonalInformation({ personalInformation, isPartofRegistration }) {
    console.log("saving personal information")
    let payload = { ...personalInformation };

    payload.doNotTriggerEvent = 'false';
    if (typeof isPartofRegistration == 'boolean' && isPartofRegistration) {
      payload.doNotTriggerEvent = 'true';
    }
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v2/personalInformation',
      payload,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    console.log('rsponse:' + resp.data);
    console.log('rsponse:' + resp.data.meta.success);
    if (resp.data.meta.success) {
      this.getProfileStrength();
    }
    // router.push("myprofile");

    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async getConfigDetails() {
    const companyCode = this.getCompanyCode;
    const token = 'Bearer ' + vxm.users.getToken;
    let newAPI = axios.get(`/configservice/api/v1/configs/${companyCode}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    Promise.all([newAPI]).then(async ([newResponse]) => {
      console.log('newResponse', newResponse);
      vxm.configs.setClientConfigs(newResponse.data);
    });
  }

  @action({ mode: 'mutate' })
  public async getProfileStrength() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/user-profile/getProfileStrength',
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    // console.log('rsponse:'+resp.data);
    this.myUserProfile.userProfileStrength = resp.data.profileStrength;
    console.log('rsponse for profile strength:' + resp.data);
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async addSkillsToUserProfile(profile: UserProfile) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/updateProfile',
      profile,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async initRegisteredUser(): Promise<WLUser> {
    // tslint:disable-next-line: one-variable-per-declaration
    const wl = window.WorkLLama;
    const wlUser = new WLUser();

    if (wl && wl.refId !== 'null') {
      this.setRefId(wl && wl.refId);
    }

    if (wl && wl.uuid !== 'null') {
      this.setUuid(wl && wl.uuid);
    }

    console.log(
      'initRegisteredUser:',
      this.refId,
      this.uuid,
      this.isPartialSignup,
    );

    if (!this.isPartialSignup) {
      return Promise.reject();
    }

    return await new Promise<WLUser>((resolve, reject) => {
      axios
        .post('/wl-profile-svc/api/anon/user-profile/getPartialProfile', null, {
          params: {
            refId: this.refId,
            uuid: this.uuid.replace(/ /g, '+'),
          },
        })
        .then((response) => {
          const profile = response.data;
          this.setUserProfile(profile);
          wlUser.userName = profile.email;
          wlUser.firstName = profile.firstName;
          wlUser.lastName = profile.lastName;
          wlUser.email = profile.email;
          wlUser.password = '';
          wlUser.phone = profile.phoneNum;
          wlUser.referralCode = profile.referralCode;
          wlUser.isEmailSystemGenerated = profile.isEmailSystemGenerated;
          wlUser.enabled = profile.accountEnabled;
          vxm.referrals.setGlobalRefCode(profile.referralCode);
          if (vxm.configs.getGlobalConfigValue('SKIP_GSU_ON_REGISTRATION_FOR_USERS_ONFILE') &&
            profile.customFields.candidateCustomMetaData && profile.customFields.candidateCustomMetaData.length > 0 &&
            profile.customFields.candidateCustomMetaData[0].label == "Application On File"
            && profile.customFields.candidateCustomMetaData[0].defaultValue
            && profile.customFields.candidateCustomMetaData[0].defaultValue.toLowerCase() == 'yes') {
            vxm.jobs.setSkipGuidedSignUpOnRegistration(true)
          }

          resolve(wlUser);

          // handle success
          console.log('then:', response);
        })
        .catch((error) => {
          // handle error
          reject(error);
          console.log('catch:', error);
        })
        .finally(() => {
          // always executed
          console.log('finally');
        });
    });
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async changeNumber(url: string) {
    try {
      const resp = await axios.get(url);
      return resp.data;
    } catch (e) {}
  }

  ////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async sendOtpCode(payload) {
    this.setEmail(payload.userEmail);
    const response = await axios.post(
      '/wl-profile-svc/api/user-profile/v2/sendOTP',
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + vxm.users.getToken,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );

    return response;
  }

  @action({ mode: 'mutate' })
  public async quickUserRegister(formData: FormData) {
    try {
      const resp = await axios.post(
        '/wl-profile-svc/api/user-profile/quickUserRegistration',
        formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
      });
      return resp.data;
      // router.push('Verification');
    } catch (error) {
      return error.response.data;
    }
  }

  @action({ mode: 'mutate' })
  public async registerUser(user: User, signupURL = '') {
    try {
      user.userName = user.email;
      user.companyCode = this.getCompanyCode;
      const userLang = Vue.cookies.get('userLang')
      user.userLocale  = userLang ? vxm.utility.languageRegionMap[userLang] : '';
      // user.userLocale = vxm.utility.langaugeRegionMapping || ""; 
      console.log(vxm.utmtracker.utmTrackerId, 'utmTrackerId');
      if (vxm.utmtracker.utmTrackerId > 0) {
        user.utmTrackerId = vxm.utmtracker.utmTrackerId;
      }
      // user.referralUrl = '';
      const resp = await axios.post(this.signupURL, user, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      console.log(resp.data);
      this.userProfile.email = user.email;
      this.userProfile.phoneNum = user.phone;

      if (user.enabled && resp.data.jwt && resp.data.jwt.accessToken) {
        this.setToken(resp.data.jwt.accessToken.token);
        this.setRefreshToken(resp.data.jwt.refreshToken.token);
        this.restartChatbotIFrame();
        await this.getUserProfile(true);
      }
      if (resp.data.success && !user.enabled) {
        const response = await this.sendOtpCode({
          userEmail: user.userName,
          companyCode: user.companyCode,
        });
        if (response.data.success) {
          response.data.successMessage =
            `${i18n.t('otp-login.toast.codesentmessage').toString()}`;
        }

        return response.data;
      } else {
        return resp.data;
      }

      // router.push('Verification');
    } catch (error) {
      return error.response.data;
    }
  }

  @action({ mode: 'mutate' })
  public async saveTermsOfServiceAndMarketingEmailFlag(
    termsOfServiceAggrement: boolean,
    marketingEmail: boolean,
  ) {
    await vxm.users.refreshProfileInfo();
    const userProfile = vxm.users.myUserProfile;
    userProfile.userAgreement = termsOfServiceAggrement === true ? 1 : 0;
    userProfile.notificationTypeMap = {
      ...userProfile.notificationTypeMap,
      MARKETING_EMAIL: marketingEmail,
    };
    const response = await vxm.users.saveUserProfile({
      userProfile,
      isPartofRegistration: false,
    });
    return response;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async registerLinkedInUser(user: User) {
    user.userName = user.email;
    user.companyCode = this.getCompanyCode;
    console.log(vxm.utmtracker.utmTrackerId, 'utmTrackerId');
    if (vxm.utmtracker.utmTrackerId > 0) {
      user.utmTrackerId = vxm.utmtracker.utmTrackerId;
    }
    // user.referralUrl = '';
    user.sourceType = 'linkedin';
    const resp = await axios.post(this.signupURL, user, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    console.log(resp.data);
    this.userProfile.email = user.email;
    this.userProfile.phoneNum = user.phone;
    if (resp.data.success) {
      await this.socialLogin(this.oauthPassport);
    }
    return resp.data;
    // router.push('Verification');
  }

  @action({ mode: 'mutate' })
  public async registerAppleUser(user: User, token) {
    user.userName = user.email;
    user.sourceType = 'apple';
    const resp = await axios.post(this.signupURL, user, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    if (resp.data.success) {
      const oauthPassport = new OAuthPassport();
      oauthPassport.email = user.email;
      oauthPassport.oAuthProvider = 'apple';
      oauthPassport.oAuthToken = token;
      await this.socialLogin(oauthPassport);
    }
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async registerFacebookUser(user: User) {
    user.userName = user.email;
    user.companyCode = this.getCompanyCode;
    console.log(vxm.utmtracker.utmTrackerId, 'utmTrackerId');
    if (vxm.utmtracker.utmTrackerId > 0) {
      user.utmTrackerId = vxm.utmtracker.utmTrackerId;
    }
    // user.referralUrl = '';
    user.sourceType = 'facebook';
    const resp = await axios.post(this.signupURL, user, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    console.log(resp.data);
    this.userProfile.email = user.email;
    this.userProfile.phoneNum = user.phone;
    if (resp.data.success) {
      await this.socialLogin(this.oauthPassport);
    }
    return resp.data;
    // router.push('Verification');
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async registerGoogleUser(user: User) {
    user.userName = user.email;
    user.companyCode = this.getCompanyCode;
    console.log(vxm.utmtracker.utmTrackerId, 'utmTrackerId');
    if (vxm.utmtracker.utmTrackerId > 0) {
      user.utmTrackerId = vxm.utmtracker.utmTrackerId;
    }
    // user.referralUrl = '';
    user.sourceType = 'google';
    const resp = await axios.post(this.signupURL, user, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    console.log(resp.data);
    this.userProfile.email = user.email;
    this.userProfile.phoneNum = user.phone;
    if (resp.data.success) {
      await this.socialLogin(this.oauthPassport);
    }
    return resp.data;
    // router.push('Verification');
  }

  //////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async userExists(lgn: AuthParams): Promise<boolean> {
    const resp = await axios.post(
      `/wl-sso-sec-svc/api/user/exists?companycode=${vxm.jobs.BrandingInfo.companycode
      }`,
      lgn,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async logout() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/logout',
      {},
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );

    if (resp.data.success) {
      this.restartChatbotIFrame();
      this.setToken('');
      this.setRefreshToken('');
      this.setAuthStatus(false);
      window.$cookies.set('OAuthProvider', '');
      window.$cookies.set('OAuthRegistrationType', '');
      router.push(
        vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN')
          ? '/login'
          : '/',
      );
      return resp.data;
    }
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async validateAppleOAuthCode(ccode: string) {}

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async validateGoogleOAuthCode(ccode: string) {
    const resp = await axios.post(
      '/wl-sso-sec-svc/getGoogleTokenv2?companycode=' +
        vxm.jobs.BrandingInfo.companycode,
      ccode,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );
    const ap = new AuthParams();
    const userData = JSON.parse(resp.data.userData);
    const accessToken = resp.data.accessToken;
    console.log('userData', userData);
    console.log('accessToken', accessToken);

    ap.username = userData.email;

    console.log('nUuserData', userData);
    this.userExists(ap).then((res) => {
      if (res === false) {
        const passport = new OAuthPassport();
        passport.oAuthProvider = 'google';
        passport.oAuthToken = accessToken;
        passport.email = userData.email;
        this.setOAuthPassport(passport);
        const nUser = new User();
        nUser.firstName = userData.given_name;
        nUser.lastName = userData.family_name;
        nUser.email = userData.email;
        nUser.emailVerified = (userData.email_verified && true === userData.email_verified ? 'true' : 'false');
        router.push({
          name: 'Signup',
          query: {
            firstName: nUser.firstName,
            lastName: nUser.lastName,
            email: nUser.email,
            emailVerified: nUser.emailVerified,
            OAuthProvider: passport.oAuthProvider,
            OAuthRegistrationType: 'google-register',
          },
        });
      } else if (res === true) {
        console.log(
          'ReferringComponent..' + Vue.cookies.get('referringComponent'),
        );
        if (Vue.cookies.get('referringComponent')) {
          router.push({
            name: Vue.cookies.get('referringComponent'),
            query: {
              fullName: userData.name,
              email: userData.email,
            },
          });
          return;
        }
        const passport = new OAuthPassport();
        passport.oAuthProvider = 'google';
        passport.oAuthToken = accessToken;
        passport.email = userData.email;
        this.setOAuthPassport(passport);
        this.socialLogin(passport);
      }
    });
  }

  ////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async retrieveEmail() {
    const resp = await axios.post(
      '/wl-sso-sec-svc/api/user/sendRetrievedEmail',
      {
        userIdStr: vxm.users.userParams.phone,
        companyCode: vxm.jobs.BrandingInfo.companycode,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    console.log('Send Retrieved Email Response', resp.data);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async updatePhoneNumberTriggerSMSOTP(otprequesttoken: OtpRequestToken) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/phonenumber/sendOTP',
      otprequesttoken,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    console.log('Verify Retrieved Email Response', resp.data);
    return resp.data;
  }
  @action({ mode: 'mutate' })
  public async ValidateUpdatePhoneNumberSMSOTP(otp: OtpValidationToken) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post('/wl-profile-svc/api/user-profile/phonenumber/activateV2',
      {
        email: otp.userIdStr,
        failedAttemptCount: otp.failedAttemptCount,
        failureCount: otp.failureCount,
        validationCode: otp.otp,
        companyCode: vxm.jobs.BrandingInfo.companycode,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      });
    console.log('OTP Response', resp.data);
    return resp;

  }


  @action({ mode: 'mutate' })
  public async validateRetrievedEmail(email: String) {
    const resp = await axios.post(
      '/wl-sso-sec-svc/api/user/verifyRetrievedEmail',
      {
        otp: email,
        userIdStr: vxm.users.userParams.phone,
        failureCount: '1',
        failedAttemptCount: 1,
        companyCode: vxm.jobs.BrandingInfo.companycode,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    console.log('Verify Retrieved Email Response', resp.data);
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async validateFacebookOAuthCode(ccode: string) {
    const url = `/wl-sso-sec-svc/getFacebookTokenv2?companycode=${vxm.jobs.BrandingInfo.companycode
    }`;
    const resp = await axios.post(url, ccode, {
      headers: { 'Content-Type': 'application/json' },
    });
    const ap = new AuthParams();
    const userData = JSON.parse(resp.data.userData);
    const accessToken = resp.data.accessToken;
    console.log(userData);
    console.log(accessToken);
    ap.username = userData.email;

    this.userExists(ap).then((res) => {
      if (res === false) {
        const passport = new OAuthPassport();
        passport.oAuthProvider = 'facebook';
        passport.oAuthToken = accessToken;
        passport.email = userData.email;
        this.setOAuthPassport(passport);

        const nUser = new User();
        nUser.firstName = userData.first_name;
        nUser.lastName = userData.last_name;
        nUser.email = userData.email;
        nUser.emailVerified = (userData.email_verified && true === userData.email_verified ? 'true' : 'false');
        router.push({
          name: 'Signup',
          query: {
            firstName: nUser.firstName,
            lastName: nUser.lastName,
            email: nUser.email,
            emailVerified: nUser.emailVerified,
            OAuthProvider: passport.oAuthProvider,
            OAuthRegistrationType: 'facebook-register',
          },
        });
      } else if (res === true) {
        console.log(
          'Facebook..ReferringComponent..' +
            Vue.cookies.get('referringComponent'),
        );
        if (Vue.cookies.get('referringComponent')) {
          router.push({
            name: Vue.cookies.get('referringComponent'),
            query: {
              fullName: userData.name,
              email: userData.email,
            },
          });
          return;
        }
        const passport = new OAuthPassport();
        passport.oAuthProvider = 'facebook';
        passport.oAuthToken = accessToken;
        passport.email = userData.email;
        this.setOAuthPassport(passport);
        this.socialLogin(passport);
      }
    });
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async validateLinkedinOAuthCode(ccode: string) {
    const url = `/wl-sso-sec-svc/getLinkedinTokenv2?companycode=${vxm.jobs.BrandingInfo.companycode
    }`;
    const resp = await axios.post(url, ccode, {
      headers: { 'Content-Type': 'application/json' },
    });
    const ap = new AuthParams();
    const userData = JSON.parse(resp.data.userData);
    const accessToken = resp.data.accessToken;
    console.log('Linkedin Profile Data', userData);
    console.log('Linkedin access token', accessToken);

    ap.username = userData.emailAddress;
    console.log('Linkedin email address', ap.username);

    this.userExists(ap).then((res) => {
      if (res === false) {
        const passport = new OAuthPassport();
        passport.oAuthProvider = 'linkedin';
        passport.oAuthToken = accessToken;
        passport.email = userData.emailAddress;
        this.setOAuthPassport(passport);

        const nUser = new User();
        nUser.firstName = userData.localizedFirstName;
        nUser.lastName = userData.localizedLastName;
        nUser.email = userData.emailAddress;
        nUser.emailVerified = (userData.email_verified && true === userData.email_verified ? 'true' : 'false');
        router.push({
          name: 'Signup',
          query: {
            firstName: nUser.firstName,
            lastName: nUser.lastName,
            email: nUser.email,
            emailVerified: nUser.emailVerified,
            OAuthProvider: passport.oAuthProvider,
            OAuthRegistrationType: 'linkedin-register',
          },
        });
      } else if (res === true) {
        const passport = new OAuthPassport();
        passport.oAuthProvider = 'linkedin';
        passport.oAuthToken = accessToken;
        passport.email = userData.emailAddress;
        this.setOAuthPassport(passport);
        this.socialLogin(passport);
      }
    });
  }

  //////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getUserInfo(token: string) {
    const resp = await axios.get(
      'https://www.googleapis.com/oauth2/v1/userinfo?access_token=' + token,
    );
    console.log(resp.data);
  }
  @action({ mode: 'mutate' })
  public async renameResume(currentResume: ResumeRecord) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/resume/rename/' +
        currentResume.fileGUID,
      { newName: currentResume.name },
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async deleteResume(currentResume: ResumeRecord) {
    const token = 'Bearer ' + this.getToken;
    var payload;
    if(!this.isLoggedIn){
         payload=  { newName: currentResume.name ,
          "userId" : currentResume.userId
         } 
    }
    else{
      payload=  { newName: currentResume.name 
       } 
    }
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/resume/delete/' +
        currentResume.fileGUID,
       
      payload,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////
  @action({ mode: 'mutate' })
  public async defaultResume(currentResume: ResumeRecord) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/resume/activate/' +
        currentResume.fileGUID,
      {},
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async uploadDropboxResume(): Promise<string> {
    const dbxUploadUrl = '/wl-profile-svc/api/user-profile/uploadResumeDropbox';
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.getToken,
      },
    };

    return new Promise<string>((resolve, reject) => {
      this.selectFromDropbox([])
        .then((selected) => {
          const file = selected.file;
          if (!!file) {
            const dbxRec = { fileLink: file.link };
            axios
              .post(dbxUploadUrl, dbxRec, config)
              .then((res) => {
                if (res.data.success) {
                  resolve(selected.status);
                } else {
                  reject('Error importing Dropbox file.');
                }
              })
              .catch((err) => {
                reject(err);
                console.log('ERR:', err);
              });
          } else {
            resolve(selected.status);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public selectFromDropbox(extensions: string[]): Promise<DropboxSelection> {
    const options: Dropbox.ChooserOptions = {
      // tslint:disable-next-line:no-empty
      success: (files) => {},

      linkType: 'direct',

      multiselect: false,
      extensions: vxm.configs
        .getGlobalConfigValue('ALLOWED_RESUME_FORMATS')
        .split(','),

      folderselect: false,
      sizeLimit: 2097152, // 2MB
    };

    try {
      return new Promise<DropboxSelection>((resolve, reject) => {
        const success = (files: ReadonlyArray<Dropbox.ChooserFile>): void => {
          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < files.length; i++) {
            resolve(DropboxSelection.success(files[i]));
            return;
          }
          reject('Error selecting Dropbox file.');
        };
        const cancel = (): void => {
          resolve(DropboxSelection.cancel());
        };
        options.cancel = cancel;
        options.success = success;
        window.Dropbox.choose(options);
      });
    } catch (ex) {
      return Promise.reject(ex);
    }
  }

  @action({ mode: 'mutate' })
  public sessionTimeout() {
    this.setToken('');
    this.setRefreshToken('');
    this.setAuthStatus(false);
    router.push({ path: '/login?sessionExpired=true' });
  }

  @action({ mode: 'mutate' })
  public async initAppRegisteredUser(userDeviceAppTkn: string) {
    console.log([userDeviceAppTkn]);
    const resp = await axios.get(
      '/wl-profile-svc/api/anon/user-profile/getappuserinfo/' +
        userDeviceAppTkn,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    console.log('resp', [resp]);
    // const profile = resp.data;
    return resp;
  }

  @action({ mode: 'mutate' })
  public async anonAppValidateOTP(otp: OtpValidationToken) {
    const resp = await axios.post('/wl-sso-sec-svc/api/user/verifyOTP', otp, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    console.log('OTP Response', resp.data);

    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async initAppUserOtpInfo(appUserOtpInfo: AppUserOtpInfo) {
    console.log([appUserOtpInfo]);
    const resp = await axios.post('/atsuser/otpappuserinfo/', appUserOtpInfo, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    console.log('resp', [resp]);
    // const profile = resp.data;
    return resp;
  }

  @action({ mode: 'mutate' })
  public async getJobHistory(userJobHistoryListRequest: Request) {
    console.log('userJobHistoryListRequest', userJobHistoryListRequest);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/getJobHistory',
      userJobHistoryListRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );

    this.setUserJobHistoryListResponse(resp.data);
    router.push({ name: 'JobHistory' });
  }

  @action({ mode: 'mutate' })
  public async saveProfilePicture(profile: UserProfile) {
    console.log('profile', profile);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const formData = new FormData();
    formData.append('file', profile.profilePictureFile);
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/saveuserprofilepicture',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }
  
  @action({ mode: 'mutate' })
  public async refreshProfileInfo() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/user-profile/getProfile',
      {
        headers: { 'Content-Type': 'application/json', Authorization: token },
      },
    );
    this.setUserProfile(resp.data);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async refreshPhoneNumber() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/user-profile/getProfile',
      {
        headers: { 'Content-Type': 'application/json', Authorization: token },
      },
    );
    console.log(resp.data.phoneNum);
    this.userProfile.phoneNum = resp.data.phoneNum;

    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async unsubscribeTheNotification(userId: string) {
    const resp = await axios.post(
      `/atsuser/api/anon/candidate-survey/userUnsubscribe?userId=${userId}`,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async isUnsubscribeRequestValid(data: string) {
    const resp = await axios.get(
      `/atsuser/api/anon/candidate-survey/unsubscribe?userId=${data['userId']
      }&email=${data['email']}&uuid=${data['uuid']}`,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async confirmPhoneNumber(hash: string) {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/phonenumber/activation',
      {
        validationCode: hash,
        companyCode: vxm.jobs.BrandingInfo.companycode,
      },
      {
        headers: { 'Content-Type': 'application/json', Authorization: token },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async confirmEmailAddrress(hash: string) {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/confirmEmailAddrress/' +
        vxm.jobs.BrandingInfo.companycode,
      hash,
      {
        headers: { 'Content-Type': 'application/json', Authorization: token },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async changeEmailAddress(changeEmailRequest: ChangeEmailRequest) {
    const bearerToken = 'Bearer ' + this.getToken;
    changeEmailRequest.sessionToken = vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/changeEmailAddress',
      changeEmailRequest,
      //'/wl-profile-svc/api/user-profile/changeEmailAddress',
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    console.log('rsponse for profile strength:' + resp.data);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async changePhoneNumber(
    changePhoneNumberRequest: ChangePhoneNumberRequest,
  ) {
    const bearerToken = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/phonenumber',
      changePhoneNumberRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    console.log('response for change phone number:' + resp.data);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async confirmOtp(
    changephonenumberconfirmotprequest: ChangePhoneNumberConfirmOtpRequest,
  ) {
    const bearerToken = 'Bearer ' + this.getToken;
    changephonenumberconfirmotprequest.sessionToken = vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/confirmOtp',
      changephonenumberconfirmotprequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    console.log('response for profile number:' + resp.data);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async changePhoneNumberResendOTP() {
    const bearerToken = 'Bearer ' + this.getToken;
    var changePhoneNumberResendOtpRequest = new ChangePhoneNumberResendOtpRequest();
    changePhoneNumberResendOtpRequest.sessionToken = vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/resendOtp',
      changePhoneNumberResendOtpRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    console.log('response for profile number:' + resp.data);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async listEducationHistory() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/education?pageSize=500&pageNumber=1',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    const list = response.data.data.educationHistoryList.map((item) => {
      if (item.startDate) {
        item.startDate = vxm.utility.convertUTCToLocalTime(
          Number(item.startDate),
        );
      }
      if (item.completionDate) {
        item.completionDate = vxm.utility.convertUTCToLocalTime(
          Number(item.completionDate),
        );
      }
      return item;
    });
    this.setEducationHistoryList(list);
  }

  @action({ mode: 'mutate' })
  public async saveEducationHistory(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/v1/education',
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
  }

  @action({ mode: 'mutate' })
  public async updateEducationHistory(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/v1/education',
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
  }

  @action({ mode: 'mutate' })
  public async deleteEducationHistory(id) {
    const response = await axios.post(
      `/wl-profile-svc/api/v1/education/${id}`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
  }

  @action({ mode: 'mutate' })
  public async updateSkills(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/v1/skills',
      payload,
      {
        params: {
          locale: vxm.utility.langaugeRegionMapping
        },
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
  }

  @action({ mode: 'mutate' })
  public async listProfessionalReference() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/references?pageSize=10&pageNumber=1',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    const list = response.data.data.candidateProfessionalReferencesList.map(
      (item) => {
        if (item.workedTogetherFrom) {
          item.workedTogetherFrom = vxm.utility.convertUTCToLocalTime(
            Number(item.workedTogetherFrom),
          );
        }
        if (item.workedTogetherTo) {
          item.workedTogetherTo = vxm.utility.convertUTCToLocalTime(
            Number(item.workedTogetherTo),
          );
        }
        return item;
      },
    );
    this.setProfessionalReferenceList(list);
  }

  @action({ mode: 'mutate' })
  public async saveProfessionalReference(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/v1/references',
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    return response.data.meta;
  }

  @action({ mode: 'mutate' })
  public async updateProfessionalReference(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/v1/references',
      payload,
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    return response.data.meta;
  }
  @action({ mode: 'mutate' })
  public async deleteProfessionalReference(myobj) {
    const response = await axios.post(
      '/wl-profile-svc/api/v1/references/delete',
      myobj,
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    return response.data.meta;
  }
  @action({ mode: 'mutate' })
  public setSelectedAnswer({ questionID, answerID, linkedQuestionId = null }) {
    const questionCheckList = this.questionCheckList.map((template) => {
      const questionList = template.questionList.map((question) => {
        let userQuestionResponse = question.userQuestionResponse || {};
        let linkedQuestions = question.linkedQuestion;
        if (question.questionID === questionID) {
          if (linkedQuestionId) {
            linkedQuestions = question.linkedQuestion.map((linkedQuestion) => {
              if (linkedQuestion.questionID === linkedQuestionId) {
                return {
                  ...linkedQuestion,
                  userQuestionResponse: {
                    ...linkedQuestion.userQuestionResponse,
                    userAnswerList: answerID ? [answerID] : [],
                  },
                };
              }
              return { ...linkedQuestion };
            });
          } else {
            userQuestionResponse = {
              ...question.userQuestionResponse,
              userAnswerList: answerID ? [answerID] : [],
            };
          }
        }
        return {
          ...question,
          userQuestionResponse,
          linkedQuestion: linkedQuestions,
        };
      });
      return { ...template, questionList };
    });
    this.setQuestionCheckList(questionCheckList);
  }

  @action({ mode: 'mutate' })
  public async fetchSkillQuestions(skillId) {
    const response = await axios.get(
      `/wl-profile-svc/api/v1/skillType/${skillId}/questions`,
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    this.setQuestionCheckList(response.data.data.questionCheckList);
    this.setCheckListMetaData(response.data.data.checkListMetaData);
  }

  @action({ mode: 'mutate' })
  public async saveSkillCheckListAnswer({
    skillId,
    type,
    certifiedBy,
    certifiedDate,
  }) {
    const payload: Array<any> = [];
    this.questionCheckList.forEach((template) => {
      template.questionList.map((question) => {
        payload.push({
          questionId: question.questionID,
          userQuestionResponse: {
            userAnswerList: question.userQuestionResponse.userAnswerList || [],
          },
          questionTextResponse: '',
        });
        if (question.linkedQuestion) {
          question.linkedQuestion.map((question) => {
            payload.push({
              questionId: question.questionID,
              userQuestionResponse: {
                userAnswerList:
                  (question.userQuestionResponse &&
                    question.userQuestionResponse.userAnswerList &&
                    question.userQuestionResponse.userAnswerList) ||
                  [],
              },
              questionTextResponse: '',
            });
          });
        }
      });
    });
    const response = await axios.post(
      `/wl-profile-svc/api/v1/${type}/saveCandidateSkillCheckList`,
      {
        skillTypeId: skillId,
        questionResponseData: payload,
        certifiedBy: certifiedBy,
        certifiedDate: certifiedDate,
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
  }
  @action({ mode: 'mutate' })
  public async listCertificationQuestions() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/certification/question',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    this.setCertificationQuestionList(response.data.data.certificateQuestions);
  }

  @action({ mode: 'mutate' })
  public setSelectedCertificationAnswer({ questionID, answerID }) {
    const questionCertification = this.CertificationQuestionList.map(
      (template) => {
        const questionList = template.questionList.map((question) => {
          let userQuestionResponse = question.userQuestionResponse;
          if (question.questionID === questionID) {
            userQuestionResponse = {
              ...question.userQuestionResponse,
              userAnswerList: answerID ? [answerID] : [],
            };
          }
          return { ...question, userQuestionResponse };
        });
        return { ...template, questionList };
      },
    );
    this.setCertificationQuestionList(questionCertification);
  }

  @action({ mode: 'mutate' })
  public async saveCertificateAnswers(userID) {
    const payload: Array<any> = [];
    let isAnsweredRequiredQuestions = true;
    this.CertificationQuestionList.forEach((template) => {
      template.questionList.map((question) => {
        if (
          question.questionType !== '09' &&
          question.questionRequired &&
          (!question.userQuestionResponse ||
            (question.userQuestionResponse &&
              !question.userQuestionResponse.userAnswerList[0]))
        ) {
          isAnsweredRequiredQuestions = false;
        }
        payload.push({
          questionId: question.questionID,
          userQuestionResponse: {
            userAnswerList:
              (question.userQuestionResponse &&
                question.userQuestionResponse.userAnswerList) ||
              [],
          },
          questionTextResponse: '',
        });
      });
    });
    if (!isAnsweredRequiredQuestions) {
      return Promise.reject('Please select all required questions');
    }
    return await axios.post(
      '/wl-profile-svc/api/v1/certification/answers',
      {
        userId: userID,
        questionResponseData: payload,
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
  }

  @action({ mode: 'mutate' })
  public async fetchDegreeOptions() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/education/degree/list',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    this.setDegreeOptions(response.data.data);
  }

  @action({ mode: 'mutate' })
  public async validateMandatorySteps() {
    const response = await axios.get(
      '/wl-profile-svc/api/v3/profilewizard/requiredsteps',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    const missedSteps = response.data.data.requiredStepsMissing.map(
      (stepName) => {
        const stepMapping = {
          RESUME: 'Resume',
          SKILLS: 'Skills',
          SKILLS_AND_SPECIALITY: 'Skills',
          EDUCATION_HISTORY: 'Education History',
          WORK_EXPERIENCE: 'Work Experience',
          PROFESSIONAL_REFERENCE: 'Professional Reference',
          JOB_PREFERENCE: 'Job Preference',
          WORK_PREFERENCE: 'Job Preference',
          SOURCE_TYPE: 'Source',
          ADDRESS: 'Address',
          PROTECTED_INFORMATION: 'Protected Information',
          WERE_YOU_REFERRED: 'Were you referred?',
          PROFILE_PICTURE: 'Profile Picture',
          MY_DOCUMENTS: 'My Documents',
          LANGUAGE: 'Language',
          
        };
        return stepMapping[stepName];
      },
    );
    this.setMissedMandatorySteps(missedSteps);
  }

  @action({mode: 'mutate'})
  public async fetchInMailChatConversation(userId: number){
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-messaging-service/api/v1/fetch-email-conversations',
      {
        "candidateId":userId,
        "orderby":{
            "isAsc":true
        },
      },
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  @action({mode: 'mutate'})
  public async fetchAnonInMailChatConversation(token:string){
    const resp = await axios.post(
      '/wl-messaging-service/api/v1/anon/candidate/fetch-email-conversations',
      {
        "token": token,
        "orderby":{
            "isAsc":true
        },
      },
     
    );
    return resp.data;
  }

  @action({mode: 'mutate'})
  public async sendInMailChatConversation(formData: FormData){
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-messaging-service/api/v1/candidate/send-email',
      formData,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }
  @action({mode: 'mutate'})
  public async sendInMailAnonChatConversation(formData: FormData){
    const token = formData.get('token');
    formData.delete('token')
    const resp = await axios.post(
      '/wl-messaging-service/api/v1/anon/candidate/send-email?token='+token,
      formData,
    );
    return resp.data;
  }

  

  @action({ mode: 'mutate' })
  public async fetchWizardSteps() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/profilewizard/steps',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    this.setProfileWizardSteps(response.data.data.profileWizardList);
  }

  @action({ mode: 'mutate' })
  public async updateProtectedInformation(dateofbirth: String) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/updateProtectedInformation/' +
        dateofbirth,
      null,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  @mutation
  public setRequiredStepsInfo(payload) {
    this.requiredStepsInfo = payload;
  }


  @mutation
  public setMissingStepsEstimateInfo(payload) {
    this.missingStepsEstimateInfo = payload;
  }  

  @action({ mode: 'mutate' })
  public async getProfileWizardStepInfo() {
    const response = await axios.get(
      '/wl-profile-svc/api/v3/profilewizard/requiredsteps',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    const missedSteps = response.data.data.requiredStepsMissing.map(
      (stepName) => {
        const stepMapping = {
          RESUME: 'Resume',
          SKILLS: 'Skills',
          SKILLS_AND_SPECIALITY: 'Skills',
          EDUCATION_HISTORY: 'Education History',
          WORK_EXPERIENCE: 'Work Experience',
          PROFESSIONAL_REFERENCE: 'Professional Reference',
          JOB_PREFERENCE: 'Job Preference',
          WORK_PREFERENCE: 'Job Preference',
          SOURCE_TYPE: 'Source',
          ADDRESS: 'Address',
          PROTECTED_INFORMATION: 'Protected Information',
          WERE_YOU_REFERRED: 'Were you referred?',
          PROFILE_PICTURE: 'Profile Picture',
          MY_DOCUMENTS: 'My Documents',
          LANGUAGE: 'Language',
          
        };
        return stepMapping[stepName];
      },
    );
    this.setMissedMandatorySteps(missedSteps);
    this.setRequiredStepsInfo(response.data.data);
  }

  
  @action({ mode: 'mutate' })
  public async getProfileWizardMissingStepEstimate() {
    const response = await axios.get(
      '/wl-profile-svc/api/v3/profilewizard/misssingstepsestimate',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    this.setMissingStepsEstimateInfo(response.data.data);
  }

  @action({ mode: 'mutate' })
  public async getProfileWizardCertificationStepStatus() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/profilewizard/certification/status',
      {
        headers: {
          Authorization: 'Bearer ' + this.getToken,
        },
      },
    );
    return response.data.data;
  }

  @action({ mode: 'mutate' })
  public async saveUserDisciplines(payload) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/candidateCustomData',
      payload,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async fetchUserRoles() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.get(
      `/wl-profile-svc/api/v1/roles/${vxm.jobs.BrandingInfo.companycode}`,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    const data = resp.data.data.filter(
      ({ roleName }) => roleName.indexOf('CustomProfile') === -1,
    );
    this.setUserRoles(data);
  }

  @action({ mode: 'mutate' })
  public async saveUserRole(payload) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post('/wl-profile-svc/api/v1/role/save', payload, {
      headers: { 'Content-Type': 'application/json', Authorization: token },
    });

    if (resp.data && resp.data.meta && resp.data.meta.success) {
      this.getProfileStrength();
    }
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async removeData() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post('/wl-profile-svc/api/v2/dataPrivacy', null, {
      headers: { 'Content-Type': 'application/json', Authorization: token },
    });
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async sePwdAcctStatus(status: boolean) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v2/user-profile/updatePwdAccountStatus',
      status,
      {
        headers: { 'Content-Type': 'application/json', Authorization: token },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async getWereYouReferredDetail() {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v2/referral/wereyoureferred',
      {
        headers: { 'Content-Type': 'application/json', Authorization: token },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async saveWereYouReferredDetail(payload) {
    const token = 'Bearer ' + this.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v2/referral/updateReferringUserInfo', payload,
      {
        headers: { 'Content-Type': 'application/json', Authorization: token },
      },
    );
    console.log(resp);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  private restartChatbotIFrame() {
    // send postMessage to current chatbot to clean senderId from localstorage
    const chatBotFrame: any = document.getElementById('myframe');
    // if (chatBotFrame && !chatBotFrame.src) {
    //   chatBotFrame.src = window.WorkLLama.chatbotWidgetUrl;
    // }

    let isUrlValid = false;
    try {
      new URL(window.WorkLLama.chatbotWidgetUrl);
      isUrlValid = true;
    } catch (_) {
      isUrlValid = false;
    }
    // console.log('chatBotFrame: ', chatBotFrame);
     if (chatBotFrame && isUrlValid) {
      chatBotFrame.contentWindow.postMessage(
        'remove_sender_id',
        window.WorkLLama.chatbotWidgetUrl,
      );

      if (
        chatBotFrame &&
        (chatBotFrame.src != null || chatBotFrame.src.length != 0)
      ) {
        chatBotFrame.src = '';
      } else {
        chatBotFrame.src = chatBotFrame.src;
      }
      
    }

  }

  @action({ mode: 'mutate' })
  public async fetchPersonalInformation() {
    try {

      const token = 'Bearer ' + this.getToken;
      const response = await axios.get(
        '/wl-profile-svc/api/v2/personalInformation',
        { headers: { 'Content-Type': 'application/json', Authorization: token } },
      );
      if (response.data && response.data.meta.success) {
        this.setPersonalInformation(response.data.data);
    }
    } catch (error) {
      console.error('Error fetching personal information:', error);
    }
  }
@action({ mode: 'mutate' })
  public async fetchLanguagePreference() {
    try {

      const token = 'Bearer ' + this.getToken;
      const response = await axios.get(
        '/wl-profile-svc/api/v1//user-preference/locale',
        { headers: { 'Content-Type': 'application/json', Authorization: token } },
      );
      if (response.data && response.data.meta.success) {
        const userLanguagePreference = response.data.data
        this.setUserLanguagePrefrence(userLanguagePreference)
        return userLanguagePreference;
      }
      else{
        return 'en';
      }
    } catch (error) {
      console.error('Error fetching language preference:', error);
    }
  }

}
